export default function addDepositphotosLink(text) {
  const words = text.split(' ');
  return words.map((word, index) => {
    if (word.includes('depositphotos')) {
      return (
        <a
          key={index}
          className="tw-text-primary-200 hover:tw-underline"
          target="_blank"
          rel="sponsored noreferrer noopener"
          href="https://depositphotos.com"
        >
          Depositphotos
        </a>
      );
    } else {
      return word + ' ';
    }
  });
}
